<template>
    <div class="user">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>用户管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>用户管理</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="公司">
                        <el-input v-model="searchForm.company" placeholder="公司" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱">
                        <el-input v-model="searchForm.email" placeholder="用户邮箱" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="账号状态" size="mini" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="待审核" value="0"></el-option>
                            <el-option label="通过" value="1"></el-option>
                            <el-option label="驳回" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary"
                            @click="() => {
                            this.currentPage=1;
                            onSearch();}"
                            size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    stripe
                    size="mini"
                    :data="tableData"
                    :height="tableConfig.height"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column
                        prop="company"
                        label="公司">
                    </el-table-column>
                    <el-table-column
                        prop="email"
                        label="邮箱"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        prop="reason"
                        label="驳回理由"
                        width="200">
                    </el-table-column>
                    <el-table-column
                            prop="status"
                            label="状态"
                            width="100">
                        <template slot-scope="scope">
                            <el-tag size="mini"
                                    :type="scope.row.status ===  1 ? 'success' : (scope.row.status ===  2 ? 'info' : 'warning')"
                                    disable-transitions>{{scope.row.status === 1 ? '通过' : (scope.row.status ===  2 ? "驳回" : "待审核") }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="350" align="right">
                        <template slot-scope="scope">
                            <el-button type="text"
                                size="mini"
                                :disabled="scope.row.status !== 0"
                                @click="handlePass(scope.row)">通过</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button
                                size="mini" type="text"
                                :disabled="scope.row.status !== 0"
                                @click="handleReject(scope.row)">拒绝</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :total="total"
                        :page-size="pageSize"
                        :current-page="currentPage"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {

    data() {
        return {
            tableConfig: {
                height: 0,
            },
            searchForm: {
                company: "",
                email: "",
                status: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
        }
    },
    methods: {
        onSearch() {
            let user = {
            };
            if(this.searchForm.company != "") {
                user["company"] = this.searchForm.company;
            }
            if(this.searchForm.email != "") {
                user["email"] = this.searchForm.email;
            }
            if(this.searchForm.status != "") {
                user["status"] = this.searchForm.status;
            }

            this.loading = true;
            let _this = this
            this.$axios.post("/admin/user/apply/search",{
                cond: user,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handlePass(row) {
            const that = this;
            this.$confirm('通过申请将自动创建公司和管理员账号，是否确定通过？', '通过', {
                confirmButtonText: '通过',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$axios.post("/admin/user/apply/pass",{
                    id: row['id'],
                }).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '已驳回申请',
                            type: 'success'
                        });
                        that.onSearch();
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            });
        },
        handleReject(row) {
            const that = this;
            this.$prompt('请输入驳回理由', '驳回', {
                confirmButtonText: '驳回',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(({value}) => {
                that.$axios.post("/admin/user/apply/reject",{
                    id: row['id'],
                    reason: value,
                }).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '已驳回申请',
                            type: 'success'
                        });
                        that.onSearch();
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            });
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
        this.onSearch();
    },
    mounted() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            loading.close();
        }, 500);
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style>
</style>
